const MODULE_BASE = `${process.env.REACT_APP_PATH_MAP_BASE}/cal-user-pref`

const TZ_SETTING_PATH = `${MODULE_BASE}/tz-setting`

const pathMap = {
  TZ_USER_PREF_SETTING: TZ_SETTING_PATH
}

export default pathMap
